import Recommend from './Recommend'

export default Recommend
